__turbopack_context__.v({
  "dot": "ThinkingIndicator-module__jMxpFq__dot",
  "dots": "ThinkingIndicator-module__jMxpFq__dots",
  "pulse": "ThinkingIndicator-module__jMxpFq__pulse",
  "thinkingIndicator": "ThinkingIndicator-module__jMxpFq__thinkingIndicator",
});
